import { render, staticRenderFns } from "./pcNew.vue?vue&type=template&id=14a2d4f2&scoped=true&"
import script from "./pcNew.vue?vue&type=script&lang=js&"
export * from "./pcNew.vue?vue&type=script&lang=js&"
import style0 from "./pcNew.vue?vue&type=style&index=0&id=14a2d4f2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14a2d4f2",
  null
  
)

export default component.exports